import { render } from "./search-form-sort.vue?vue&type=template&id=312ac9df&scoped=true"
import script from "./search-form-sort.vue?vue&type=script&lang=js"
export * from "./search-form-sort.vue?vue&type=script&lang=js"

import "./search-form-sort.vue?vue&type=style&index=0&id=312ac9df&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-312ac9df"]])

export default __exports__